import { GetUserRoleResponse, UserOrganizations } from '@esg/business-account';
import { genericAtom } from './jotai';

export interface CustomerProfile {
    readonly id: string;
    readonly fullName: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly avatar?: string;
    readonly customerCode: string;
    readonly email?: string;
    readonly phone?: string;
    readonly dateOfBirth?: string;
    readonly allowSendSms?: boolean;
    readonly phoneCountryCode?: string;
    readonly totalPackage?: number;
}

export interface IdentityUserProfile {
    readonly id: string;
    readonly username: string;
    readonly email: string;
    readonly userRoles?: GetUserRoleResponse[];
    readonly userOrganizations: UserOrganizations[];
}

export interface IBreakTime {
    readonly id?: string;
    readonly startTime: string;
    readonly endTime: string;
    readonly dayOfWeek: number;
    readonly dayOfWeekTitle: string;
    readonly isFixed?: boolean;
    readonly employeeId?: string;
    readonly shiftId?: string;
    readonly businessHourId?: string;
}


export interface IBusinessHour {
    readonly id?: string;
    readonly isDayOff: boolean;
    readonly startTime: string;
    readonly endTime: string;
    readonly openTime: string;
    readonly closeTime: string;
    readonly dayOfWeek: number;
    readonly dayOfWeekTitle: string;
    readonly breakTimes?: IBreakTime[];
}

export interface ManagementUserProfile {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly email: string;
    readonly avatar: string;
    readonly phoneNumber: string;
    readonly createdAt: string;
    readonly loginMethods: string[];
    readonly userRoles?: GetUserRoleResponse[];
    readonly organization: {
        readonly id: string;
        readonly name: string;
        readonly phoneNumber?: string;
    };
    readonly branchActive?: string;
    readonly branch: {
        readonly id: string;
        readonly name: string;
        readonly logo?: string;
        readonly countryCode?: string;
        readonly phoneNumber?: string;
        readonly currency?: string;
        readonly tax?: string;
        readonly taxCode?: string;
        readonly dateTimeFormat?: string;
        readonly timezone?: string;
        readonly languages?: string;
        readonly address: string;
        readonly city: string;
        readonly state: string;
        readonly postalCode: string;
        readonly country: string;
        readonly organizationId?: string;
        readonly businessHour: IBusinessHour[];
    };
}

export const managementProfileState = genericAtom<ManagementUserProfile | null>(
    null
);

export const identityProfileState = genericAtom<IdentityUserProfile | null>(
    null
);

export const customerProfileState = genericAtom<CustomerProfile | null>(null);
